import(/* webpackMode: "eager" */ "/home/interim/frontend/app/joboffers/page.tsx");
